import { DreamityAccountResDto } from '@/store/types/account.types'
import { useLanguage } from '@/hooks/useLanguage'
import { t } from '@/utils/i18n'
import { IconMoney, IconTrendDown } from '@/components/icons/Icons'

interface AccountActionButtonsProps {
  /** 계좌 정보 */
  account: DreamityAccountResDto
  /** 입금 버튼 클릭 핸들러 */
  onDeposit: (account: DreamityAccountResDto) => void
  /** 출금 버튼 클릭 핸들러 */
  onWithdraw: (account: DreamityAccountResDto) => void
  /** 추가 CSS 클래스 */
  className?: string
}

/**
 * 계좌 액션 버튼 컴포넌트
 * 입금, 출금 버튼을 NativeWind(Tailwind) 스타일로 제공
 */
function AccountActionButtons({
  account,
  onDeposit,
  onWithdraw,
  className = '',
}: AccountActionButtonsProps) {
  const { language } = useLanguage()

  const btnBase =
    'flex-1 min-w-0 inline-flex items-center justify-center gap-1 py-2 px-1 font-medium rounded-xl cursor-pointer transition-all duration-200 text-sm whitespace-nowrap overflow-hidden text-ellipsis min-h-[2.75rem] border-0'

  return (
    <div className={`flex flex-row flex-nowrap justify-between gap-2 pt-4 border-t border-[var(--color-card-border)] w-full ${className}`}>
      <button
        type="button"
        onClick={() => onDeposit(account)}
        className={`${btnBase} bg-gradient-to-br from-gray-500 to-gray-600 text-white hover:from-gray-600 hover:to-gray-700 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-gray-500/30`}
      >
        <IconMoney size={18} className="shrink-0 block" />
        {t('accounts.deposit', language) || '입금'}
      </button>
      <button
        type="button"
        onClick={() => onWithdraw(account)}
        className={`${btnBase} bg-gradient-to-br from-gray-400 to-gray-500 text-white hover:from-gray-500 hover:to-gray-600 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-gray-400/30`}
      >
        <IconTrendDown size={18} className="shrink-0 block" />
        {t('accounts.withdraw', language) || '출금'}
      </button>
    </div>
  )
}

export default AccountActionButtons

